import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import I18n from 'i18n-js';
import cx from 'classnames';
import { Button, Popover } from 'grab-ui';
import ContextualOnboarding from 'components/v2/contextual-onboarding/contextual-onboarding';
import GroupingTipsOnboarding from './groupingTipsOnboarding/groupingTipsOnboarding';
import { MSDIcon, SingleBookingIcon } from './icons';
import styles from './styles.less';

const OrderActionButton = ({
  icon,
  action,
  className,
  onClick,
  validation,
}) => {
  const IconComp = icon;
  if (!validation || validation.error || validation.validating) {
    return (
      <Popover
        overlayClassName={styles.orderActionErrorPopup}
        placement={'top'}
        content={
          (validation && validation.error) ||
          I18n.t('shopify.orders.validation.validating')
        }
      >
        <span
          className={cx(
            styles.orderActionButton,
            styles.orderActionButtonDisabled,
            className,
          )}
        >
          {IconComp && (
            <IconComp className={styles.orderActionButtonIcon} disabled />
          )}
          {action}
        </span>
      </Popover>
    );
  }

  return (
    <Button
      onClick={onClick}
      className={cx(styles.orderActionButton, className)}
    >
      {IconComp && <IconComp className={styles.orderActionButtonIcon} />}
      {action}
    </Button>
  );
};

OrderActionButton.propTypes = {
  icon: PropTypes.func.isRequired,
  action: PropTypes.string.isRequired,
  className: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  validation: PropTypes.shape({}).isRequired,
};

const OrderActions = ({
  selectedFulfillmentOrders,
  bookMSD,
  MSDValidation,
  bookSingle,
  singleBookingsValidation,
}) => {
  const count = selectedFulfillmentOrders.length;
  return ReactDOM.createPortal(
    <div className={styles.orderActionsContainer}>
      <a
        className={styles.helpLink}
        href="https://help.grab.com/merchant/en-sg/4414949171865"
        target="_blank"
        rel="noopener noreferrer"
      >
        ?
      </a>
      <div className={styles.orderActions}>
        <div id="shopifyGroupingTips" className={styles.groupingTips}>
          <div className={styles.selectedOrders}>
            {selectedFulfillmentOrders.length} orders selected
          </div>
          <OrderActionButton
            icon={MSDIcon}
            onClick={bookMSD}
            action={I18n.t('shopify.orders.bookMSD')}
            className={styles.orderActionMSDBooking}
            validation={MSDValidation}
          />
        </div>
        <OrderActionButton
          icon={SingleBookingIcon}
          onClick={bookSingle}
          action={I18n.t(`shopify.orders.bookSingle${count > 1 ? 'Pl' : ''}`, {
            count,
          })}
          className={styles.orderActionSingleBooking}
          validation={singleBookingsValidation}
        />
      </div>
      {MSDValidation &&
        !MSDValidation.error &&
        !MSDValidation.validating && (
          <ContextualOnboarding
            elementID="shopifyGroupingTips"
            onboardingID="shopifyGroupingTips"
            onboardingVisual={<GroupingTipsOnboarding />}
            onboardingVisualPlacement={'topRight'}
            maxOnboardingTimes={1}
          />
        )}
    </div>,
    document.getElementById('root'),
  );
};

export default OrderActions;
